export class DatetimePicker {

  constructor() {
    
    jQuery.datetimepicker.setLocale('ja');
    $('.datetimepicker').datetimepicker({
      format:'Y-m-d H:i',
      step:15
    });
    
  }

}